import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setUsers } from "../users/userSlice";
import { setOwners, setPagination } from "./ownerSlice";
import { setFirstMessages, setMessages } from "../messages/messageSlice";
import { replaceOwnerThreads } from "../messageThreads/messageThreadSlice";

const buildParams = (unique_owner_id, page, per_page, thread_id) => {
  const result = { unique_owner_ids: [unique_owner_id] }

  if (page) result.page = page

  if (thread_id) result.thread_id = thread_id

  if (per_page) result.per_page = per_page

  return result
}

export const fetchInitialLoad = createAsyncThunk(
  'app/fetchInitialLoad',
  async ({ unique_owner_id, page, per_page, thread_id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/api/messaging/initial_load', {
        params: buildParams(unique_owner_id, page, per_page, thread_id),
      })

      const data = response?.data
      const { message_threads } = data

      for (let thread_id in message_threads) {
        const { last_seen_id, messages } = message_threads[thread_id]
        const unseen = messages.filter((message_id) => message_id > last_seen_id).length
        message_threads[thread_id].unseen_count = unseen > 9 ? '9+' : String(unseen)
      }

      dispatch(setFirstMessages(data?.first_messages))
      dispatch(setOwners(data?.owners))
      dispatch(replaceOwnerThreads({ threads: data?.message_threads, owner_id: unique_owner_id }))
      dispatch(setMessages(data?.messages))
      dispatch(setUsers(data?.users))
      dispatch(setPagination({ id: unique_owner_id, data: data?.pagination }))

      return data
    } catch (error) {
      console.log('error', error)
      return rejectWithValue(error.message)
    }
  }
)
